module.exports = __webpack_public_path__ + "static/blue-red-pipewrench-27d40761176cc3e0674e0f78fd085659.jpg";